import Popup from './components/Popup';
import './App.css';
import React, { useState} from 'react'


function App() {
  document.title = 'Glassmorphism Popup'
  const [buttonPopup, setButtonPopup] = useState(false);

  return (
    <div className="App">
      <main>
        <div className="container" id="container">
          <h1>What is Glassmorphism?</h1>
          <br></br>
          <h4>Glassmorphism is a unified name for the popular Frost...</h4>
          <br></br>
          <button
            className="btn"
            onClick={() => setButtonPopup(true)}>Read More
          </button>
        </div>
        
      </main>
      <Popup
        trigger={buttonPopup}
        setTrigger={setButtonPopup}
        >
      </Popup>
    </div>
  );
}

export default App;
